import { createSlice } from "@reduxjs/toolkit";

import {
  addShiftAssignmentData,
  addTeamAssignmentData,
  fetchStaffDutyCalendarData,
  removeShiftAssignmentData,
} from "../thunks/staffDutyCalendarThunks";

import type {
  ShiftAssignment,
  TimeOffEntry,
} from "../../utils/types/staffDutyCalendar";

interface StaffDutyCalendarState {
  assignments: ShiftAssignment[];
  timeOff: TimeOffEntry[];
  loading: boolean;
  error: string | null;
  isDataFetched: boolean;
  currentRequestId?: string;
}

const initialState: StaffDutyCalendarState = {
  assignments: [],
  timeOff: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const staffDutyCalendarSlice = createSlice({
  name: "staffDutyCalendar",
  initialState,
  reducers: {
    resetStaffDutyCalendarFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffDutyCalendarData.pending, (state, action) => {
        state.currentRequestId = action.meta.requestId;
        state.loading = true;
        state.isDataFetched = true;
        state.error = null;
      })
      .addCase(fetchStaffDutyCalendarData.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.currentRequestId = undefined;
        state.assignments = action.payload.assignments;
        state.timeOff = action.payload.timeOff;
        state.loading = false;
      })
      .addCase(fetchStaffDutyCalendarData.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.currentRequestId = undefined;
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });

    builder
      .addCase(addShiftAssignmentData.fulfilled, (state, action) => {
        state.assignments = [...state.assignments, action.payload];
      })
      .addCase(addShiftAssignmentData.rejected, (state, action) => {
        state.error =
          (action.payload as string) || "Failed to add shift assignment.";
      });

    builder
      .addCase(addTeamAssignmentData.fulfilled, (state, action) => {
        state.assignments = [...state.assignments, ...action.payload.created];
      })
      .addCase(addTeamAssignmentData.rejected, (state, action) => {
        state.error =
          (action.payload as string) || "Failed to add team to lane.";
      });

    builder.addCase(removeShiftAssignmentData.fulfilled, (state, action) => {
      state.assignments = state.assignments.filter(
        (a) => a.id !== action.payload.id
      );
    });
  },
});

export const { resetStaffDutyCalendarFetched } = staffDutyCalendarSlice.actions;
export default staffDutyCalendarSlice.reducer;
